import { FC, useCallback, useEffect, useState } from 'react';
import { useTranslations } from '@altermaind/core/i18n';
import { Banner } from '@/_shared/components/Banner';
import { useLayoutBanner } from '@/_shared/hooks/useLayoutBanner';
import { getUserWarningsCall } from '@/core/state/api/getUserWarningsCall';

const BANNER_KEY = 'banner.subscriptionMissing';

export const SubscriptionMissingBanner: FC = () => {
  const t = useTranslations('billing.subscriptionMissingBanner');
  const { setBanner } = useLayoutBanner();
  const { isSubscriptionMissing } = getUserWarningsCall.hook();
  const [isDismissed, setIsDismissed] = useState(false);

  const onClose = useCallback(() => {
    setIsDismissed(true);
    setBanner(BANNER_KEY, null);
  }, [setBanner]);

  useEffect(() => {
    if (!isSubscriptionMissing || isDismissed) {
      setBanner(BANNER_KEY, null);
      return;
    }

    setBanner(
      BANNER_KEY,
      <Banner message={t('message')} type='error' iconName='warning' onClose={onClose} />,
    );
  }, [isSubscriptionMissing, isDismissed, onClose, t, setBanner]);

  return null;
};
